import { render, staticRenderFns } from "./ParticipantNotes.vue?vue&type=template&id=366ade9a&scoped=true&"
import script from "./ParticipantNotes.vue?vue&type=script&lang=js&"
export * from "./ParticipantNotes.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantNotes.vue?vue&type=style&index=0&id=366ade9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366ade9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
